export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishedAt: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某顶流男星深夜密会神秘女子，举止亲密疑似新恋情曝光',
    excerpt: '近日有媒体拍到某顶流男星深夜与一名神秘女子同返酒店，两人全程举止亲密，疑似新恋情浮出水面。知情人透露该女子身份不简单...',
    content: '<p>近日，有知名娱记拍到当红顶流男星李某在深夜与一名神秘女子同行的画面。据拍摄者描述，两人先是在某高档餐厅共进晚餐，随后一同乘车前往位于朝阳区的一家五星级酒店。</p><p>据目击者称，两人全程举止亲密，男方多次主动为女方提包、开门，互动十分自然，完全不像是普通朋友关系。更有意思的是，女方全程戴着口罩和帽子，似乎有意遮挡面容。</p><p>知情人透露，这位神秘女子的身份不简单，据传是某知名影视公司的幕后高层，在圈内人脉广泛。此前该男星就曾多次被拍到与该女子同行，但均未引起太大关注。</p><p>截至目前，男方工作室尚未对此事做出任何回应。而粉丝群体已经炸开了锅，有人表示祝福，也有人坚决否认恋情。吃瓜群众纷纷表示：这瓜保熟吗？</p><p>值得注意的是，该男星此前一直以单身人设示人，若恋情属实，对其商业价值将产生不小影响。不过也有业内人士分析，在当下娱乐圈环境下，公开恋情反而可能成为加分项。</p>',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20nighttime%20paparazzi%20scene%20with%20a%20famous%20male%20celebrity%20in%20dark%20clothing%20walking%20with%20a%20mysterious%20woman%20outside%20a%20luxury%20hotel%2C%20warm%20street%20lights%2C%20cinematic%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20soft%20bokeh%20background%2C%20dramatic%20shadows%2C%20golden%20and%20amber%20tones&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '吃瓜一线记者',
    publishedAt: '2026-08-05T22:30:00',
    views: 1289300,
    comments: 5432,
    tags: ['顶流男星', '恋情曝光', '深夜密会', '娱乐圈'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-2',
    title: '某知名女星被曝偷税漏税数千万，工作室连夜发声明否认',
    excerpt: '税务部门最新通报显示，某知名女星涉嫌偷逃税款高达数千万元。消息一出立即引爆全网，当事人工作室连夜发布声明，称将配合调查...',
    content: '<p>据国家税务总局最新通报，在近期的税务稽查行动中，发现某知名女演员存在严重的偷逃税款问题，涉案金额高达数千万元。该消息一经发布，立刻在全网引发轩然大波。</p><p>据悉，该女星通过设立多家空壳公司、虚假合同等方式，将个人劳务报酬转化为企业经营收入，从而逃避高额个人所得税。税务机关已对其立案调查，并要求其限期补缴税款及滞纳金。</p><p>消息爆出后，当事人工作室连夜通过社交平台发布声明，表示将积极配合税务机关的调查工作，同时否认了部分网络传言中的夸大数字。声明中强调，部分差额是由于对税收政策理解不同造成的，并非主观故意逃税。</p><p>业内人士分析认为，近年来娱乐圈税务问题频发，从范某某到郑某某，再到如今的案件，反映出整个行业在税务合规方面的普遍问题。此次案件的处理结果，将对整个娱乐圈产生深远影响。</p><p>目前，该女星参与的多部影视作品和商业代言已受到不同程度影响，多个品牌方表示将密切关注事态进展。</p>',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20newsroom%20scene%20with%20tax%20documents%20and%20legal%20papers%20spread%20on%20a%20dark%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20cinematic%20composition%2C%20golden%20hour%20light%20through%20blinds%2C%20moody%20and%20serious%20tone&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '深度调查组',
    publishedAt: '2026-08-05T18:15:00',
    views: 987500,
    comments: 4230,
    tags: ['偷税漏税', '知名女星', '税务稽查', '娱乐圈'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-3',
    title: '热门综艺录制现场爆发激烈冲突，导演与嘉宾当场翻脸',
    excerpt: '某热门综艺最新一期录制过程中突发意外，总导演与一位重量级嘉宾在节目现场爆发激烈争吵，导致录制被迫中断近两小时...',
    content: '<p>据现场工作人员爆料，某卫视王牌综艺节目在最新一期录制过程中发生严重冲突事件。总导演王某与一位重量级男嘉宾在节目环节设计上产生严重分歧，双方在录制现场当场爆发激烈争吵。</p><p>知情人士透露，冲突的起因是导演组临时增加了一个具有争议性的游戏环节，该环节涉及嘉宾的隐私问题。男嘉宾当场表示拒绝参与，认为这个环节完全是为了制造话题而设计，有损艺人形象。</p><p>导演王某则坚持认为这是节目的看点之一，双方各执一词互不相让，最终演变成激烈的言语冲突。现场气氛一度非常尴尬，其他嘉宾和工作人员都不敢出声，录制被迫中断近两个小时。</p><p>最终在制片人的调解下，双方勉强达成和解，节目组同意删除争议环节，录制才得以继续。但据现场人员反映，之后的录制气氛明显不如之前，双方的互动也十分生硬。</p><p>此事在业内引发广泛讨论，不少业内人士认为，近年综艺节目为了追求收视率和话题度，确实存在过度消费嘉宾的倾向，此次事件或许是一个警示。</p>',
    category: '综艺影视',
    categorySlug: 'variety-drama',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20tense%20TV%20studio%20set%20with%20dramatic%20lighting%2C%20two%20people%20in%20heated%20argument%20silhouettes%2C%20professional%20camera%20equipment%20in%20background%2C%20warm%20studio%20lights%20creating%20dramatic%20shadows%2C%20cinematic%20tension%2C%20moody%20atmosphere&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '综艺前线哨兵',
    publishedAt: '2026-08-05T14:00:00',
    views: 765200,
    comments: 3891,
    tags: ['综艺节目', '录制冲突', '导演', '嘉宾翻脸'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-4',
    title: '千万粉丝网红直播带货翻车，产品质量遭集体投诉',
    excerpt: '拥有超过两千万粉丝的知名网红近日直播带货的商品被大量消费者投诉质量问题，退货率高达惊人的60%，平台已介入调查...',
    content: '<p>近日，拥有超过两千万粉丝的知名网红"甜心教主"在一次直播带货活动中售卖的某品牌护肤品，被大量消费者投诉存在严重质量问题。据不完全统计，该场直播的退货率高达惊人的60%。</p><p>消费者反映的问题包括：产品包装与直播展示严重不符、使用后出现过敏反应、产品质地异常稀薄、部分产品已过保质期等。有消费者将收到的产品与专柜正品进行对比，发现多处明显差异。</p><p>事件发酵后，"甜心教主"在社交平台发布道歉声明，表示将对所有购买该产品的消费者进行全额退款，并承诺今后将严格把控选品流程。然而这并未平息消费者的愤怒，不少人质疑其选品团队的专业性。</p><p>目前，直播平台已介入调查此事，并对涉事商家进行了处罚。业内人士指出，直播带货行业快速发展中，选品把关不严、夸大宣传等问题日益突出，亟需加强行业自律和监管。</p>',
    category: '网红圈',
    categorySlug: 'influencer',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20livestreaming%20influencer%20studio%20setup%20with%20beauty%20products%20on%20display%2C%20warm%20ring%20light%20illumination%2C%20professional%20streaming%20equipment%2C%20modern%20clean%20aesthetic%2C%20soft%20pink%20and%20gold%20accents%2C%20beauty%20influencer%20lifestyle%20photography&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '打假小能手',
    publishedAt: '2026-08-04T20:00:00',
    views: 654300,
    comments: 5678,
    tags: ['网红直播', '带货翻车', '产品质量', '消费者投诉'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-5',
    title: '知名导演被曝潜规则女演员，多名当事人站出来实锤',
    excerpt: '娱乐圈又曝惊天大瓜！多位女演员联合发声，指控某知名导演利用职权进行潜规则，并提供了大量聊天记录和录音作为证据...',
    content: '<p>娱乐圈再次爆出惊天丑闻！近日，多位女演员通过社交媒体联合发声，实名指控某知名电影导演张某在选角和拍摄过程中，利用职务之便对女演员进行潜规则。</p><p>据当事人之一的演员李某描述，在试镜过程中，张某多次以"深入交流角色"为由，要求单独在酒店房间见面。当她拒绝后，便被告知"不适合这个角色"。另一位当事人提供了大量微信聊天记录截图，其中包含露骨的暗示性内容。</p><p>更令人震惊的是，有当事人还提供了秘密录音，录音中可以清晰听到张某说"在这个圈子里，想要机会就得付出代价"等言论。这些证据一经公布，立即在网络上引发轩然大波。</p><p>该事件曝光后，多个行业组织和协会发表声明，强烈谴责此类行为，并呼吁娱乐圈进行彻底整顿。与该导演有合作关系的多家影视公司和品牌方也纷纷宣布暂停合作。</p><p>截至目前，张某本人及其团队尚未对此事做出任何公开回应。但有消息称，其正在筹备的新电影项目已被投资方紧急叫停。</p>',
    category: '行业揭秘',
    categorySlug: 'industry-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20dramatic%20film%20set%20with%20a%20directors%20chair%20in%20spotlight%2C%20moody%20cinematic%20lighting%2C%20film%20clapperboard%20and%20camera%20equipment%2C%20investigative%20atmosphere%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20film%20noir%20aesthetic&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '圈内知情人',
    publishedAt: '2026-08-04T16:30:00',
    views: 1432000,
    comments: 8765,
    tags: ['导演', '潜规则', '女演员', '行业黑幕', '实名举报'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-6',
    title: '某地产大亨涉嫌非法集资被警方带走，涉案金额超百亿',
    excerpt: '据知情人士透露，某知名地产集团掌门人近日被警方带走调查，涉嫌非法吸收公众存款和集资诈骗，牵涉投资者数以万计...',
    content: '<p>据多方消息证实，某知名地产集团创始人兼董事长赵某近日被警方带走协助调查。据悉，其涉嫌通过旗下多个理财平台非法吸收公众存款，涉案金额初步估计超过百亿元。</p><p>知情人透露，赵某的地产集团近年来资金链紧张，为缓解压力，通过设立多家所谓的"金融科技公司"和"财富管理平台"，以高息为诱饵向公众募集资金。这些平台表面上合法合规，实际上却是庞氏骗局，用后来投资者的钱支付前者的利息。</p><p>随着地产市场持续低迷，资金链最终断裂，大量投资者无法兑付本金和利息，引发群体性维权事件。警方在接到大量报案后，经过数月秘密调查，最终决定对赵某采取强制措施。</p><p>目前，案件正在进一步侦办中。据不完全统计，全国范围内涉及此案的投资者可能超过五万人，许多人是将毕生积蓄投入其中，损失惨重。相关部门已成立专案组，全力追缴涉案资产。</p>',
    category: '社会热点',
    categorySlug: 'social-hot',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20serious%20business%20scene%20with%20a%20luxury%20office%20building%20exterior%20at%20dusk%2C%20police%20car%20lights%20reflecting%20on%20glass%20windows%2C%20dramatic%20moody%20atmosphere%2C%20warm%20sunset%20light%20mixed%20with%20blue%20police%20lights%2C%20investigative%20journalism%20style&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '财经调查记者',
    publishedAt: '2026-08-04T10:00:00',
    views: 2100000,
    comments: 12340,
    tags: ['非法集资', '地产大亨', '警方调查', '社会热点'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'article-7',
    title: '当红小生深夜酒吧与陌生女子热舞，疑似与女友感情生变',
    excerpt: '有网友爆料在某知名酒吧偶遇当红小生王某，其与一名身材火辣的陌生女子贴身热舞，全程举止亲密。而此前其与圈内女友的感情传闻不断...',
    content: '<p>有网友在某社交平台发布了一段在知名酒吧拍摄的视频，画面中当红小生王某与一名身材火辣的神秘女子贴身热舞，两人互动十分亲密，完全沉浸在暧昧氛围中。</p><p>据拍摄者描述，当晚王某与几名友人一同来到酒吧，起初只是坐在卡座喝酒聊天。但到了深夜时分，几名女子加入他们的桌子，王某一改之前的低调姿态，与其中一名女子在舞池中热舞多时。</p><p>值得玩味的是，王某此前一直与圈内某女星传出恋情绯闻，两人多次被拍到同进同出，虽未正式官宣，但在粉丝心中早已是一对。此次酒吧事件曝光后，不少粉丝表示震惊和失望。</p><p>有知情人士透露，王某与圈内女友近期的确出现了感情问题，两人已经冷战多时。此次酒吧事件或许就是一个信号，暗示两人关系已经走到尽头。不过也有声音认为，这只是一次普通的社交活动，被过度解读了。</p>',
    category: '情感吃瓜',
    categorySlug: 'relationship',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20nightclub%20scene%20with%20colorful%20neon%20lights%20and%20silhouettes%20dancing%2C%20warm%20amber%20and%20pink%20mood%20lighting%2C%20luxury%20nightlife%20atmosphere%2C%20cinematic%20blur%20and%20bokeh%20effects%2C%20energetic%20party%20vibe&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '深夜吃瓜人',
    publishedAt: '2026-08-03T23:45:00',
    views: 876400,
    comments: 4321,
    tags: ['当红小生', '酒吧热舞', '感情生变', '夜生活'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'article-8',
    title: '某知名选秀节目被曝黑幕：选手晋级全靠背后资本运作',
    excerpt: '一位参与过某大型选秀节目的前工作人员匿名爆料，揭露了节目组如何按照赞助商和经纪公司的要求操控选手的晋级结果...',
    content: '<p>近年来选秀节目层出不穷，但背后的操作方式却一直是个谜。近日，一位自称在某大型选秀节目工作过三年的前工作人员，通过匿名方式向媒体爆料，详细揭露了节目组如何操控选手晋级的黑幕。</p><p>据这位前工作人员透露，选手能否晋级很大程度上取决于背后的资本力量。每位选手背后都有对应的经纪公司，经纪公司会与节目组进行"资源置换"——谁出的资源多，谁的选手就能走得更远。赞助商也有很大的话语权，他们心仪的选手几乎可以"保送"到后期。</p><p>爆料人还提到，所谓的"观众投票"环节也存在严重造假。节目组后台可以随时调整投票数据，让某个选手的票数在一夜之间暴涨或暴跌，完全取决于节目组和资本方的需要。有时为了制造话题和冲突，节目组还会故意淘汰人气选手。</p><p>这一爆料在网络上引发巨大反响，不少网友表示"虽然一直有这种感觉，但亲耳听到还是觉得心寒"。有业内人士呼吁，选秀行业亟需建立透明的评审机制和监管体系。</p>',
    category: '行业揭秘',
    categorySlug: 'industry-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20talent%20show%20stage%20with%20spotlight%20and%20empty%20judges%20chairs%2C%20dark%20backstage%20area%20with%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20strong%20contrast%2C%20warm%20golden%20spotlight%20and%20deep%20shadows%2C%20theatrical%20mood&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '幕后爆料人',
    publishedAt: '2026-08-03T15:20:00',
    views: 543200,
    comments: 2987,
    tags: ['选秀节目', '黑幕曝光', '资本运作', '投票造假'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'article-9',
    title: '某女团成员私下吸烟喝酒照片流出，清纯人设彻底崩塌',
    excerpt: '一组疑似某当红女团成员在私人聚会上吸烟喝酒的照片在网络上疯传，与其一直塑造的清纯甜美形象形成巨大反差...',
    content: '<p>一组疑似某当红女子组合成员在私人聚会上吸烟喝酒的照片近日在社交平台上广泛传播，引发粉丝群体激烈争论。照片中的女子手持香烟，桌上摆满了各种酒类，神态放松，与舞台上清纯甜美的形象判若两人。</p><p>该女团自出道以来，经纪公司一直为成员们打造"邻家女孩"、"清纯可爱"的人设，在公开场合严禁成员有任何不良形象展示。此次照片流出，无疑是对这一精心维护人设的巨大冲击。</p><p>照片曝光后，粉丝群体迅速分裂为两派。一部分粉丝表示"脱粉"，认为自己被欺骗了；另一部分粉丝则认为艺人私下有正常社交生活无可厚非，这些照片是偷拍，侵犯了艺人隐私。</p><p>截至目前，该成员所属的经纪公司尚未对此事做出回应。但据业内人士分析，此类"人设崩塌"事件近年来在娱乐圈屡见不鲜，根本原因在于经纪公司给艺人贴的标签过于单一和极端，与真实人性存在巨大鸿沟。</p>',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20candid%20party%20scene%20with%20warm%20intimate%20lighting%2C%20young%20people%20gathering%20in%20a%20private%20room%2C%20drinks%20on%20table%2C%20soft%20golden%20glow%2C%20paparazzi%20style%20candid%20photography%2C%20dramatic%20warm%20amber%20tones&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '人设崩塌观察员',
    publishedAt: '2026-08-03T10:00:00',
    views: 654100,
    comments: 5123,
    tags: ['女团', '人设崩塌', '吸烟', '清纯形象'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'article-10',
    title: '娱乐圈两大经纪公司暗战升级，多位艺人被卷入资源争夺',
    excerpt: '据业内人士爆料，国内两大顶级经纪公司近期因争夺头部资源和艺人合约，矛盾全面升级，多位一线明星被卷入这场暗战...',
    content: '<p>娱乐圈的竞争从来不只是台前，幕后的经纪公司之间的角力同样精彩。据多位业内人士透露，国内两大顶级经纪公司——星空娱乐和天耀传媒，近期的矛盾已经全面升级为公开对抗。</p><p>事情的导火索是双方同时看中了一位新晋爆红的年轻演员，两家公司都开出了天价签约条件，互不相让。随后，这场争夺战迅速蔓延到多个领域，包括影视项目投资、广告代言资源、综艺节目名额等。</p><p>最引人关注的是，两家公司旗下多位一线艺人也被卷入了这场暗战。有的艺人被要求拒绝与对方公司旗下的艺人合作，有的则被施压在社交媒体上与对方划清界限。一时间，娱乐圈站队现象愈发明显。</p><p>有分析人士指出，这种恶性竞争最终伤害的还是艺人自身的利益和整个行业的健康发展。在资源有限的情况下，合理竞争无可厚非，但使用如此极端的手段，只会让行业生态更加恶化。</p>',
    category: '行业揭秘',
    categorySlug: 'industry-expose',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dramatic%20corporate%20showdown%20scene%20with%20two%20tall%20modern%20office%20buildings%20facing%20each%20other%20at%20sunset%2C%20warm%20golden%20light%20with%20dramatic%20clouds%2C%20corporate%20rivalry%20atmosphere%2C%20cinematic%20wide%20shot%2C%20intense%20mood&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '娱乐圈观察家',
    publishedAt: '2026-08-02T20:00:00',
    views: 432100,
    comments: 2100,
    tags: ['经纪公司', '资源争夺', '暗战', '娱乐圈'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-11',
    title: '某知名歌手新歌被指抄袭国外小众乐队，相似度高达90%',
    excerpt: '音乐圈再爆抄袭风波！有网友通过专业音频对比发现，某知名男歌手最新发布的主打歌与一支国外小众乐队三年前的作品高度雷同...',
    content: '<p>音乐圈的抄袭争议从未停止。近日，有专业乐迷通过音频分析软件对比发现，某知名男歌手最新发布的主打歌《星光》与一支北欧小众乐队三年前的作品《Northern Lights》在主旋律、和声走向和编曲结构上高度相似，相似度高达90%。</p><p>该网友制作了详细的对比视频发布在B站上，将两首歌的旋律逐段进行对比，并标注了重合部分。视频一经发布便迅速走红，播放量在24小时内突破500万。</p><p>面对质疑，该歌手的经纪公司发表声明称，歌曲系由国际知名音乐制作团队创作，不存在抄袭行为，所谓的相似只是巧合。然而这一解释并未获得公众认可，越来越多音乐人加入讨论，认为这种程度的雷同不可能只是巧合。</p><p>目前，原创乐队的粉丝已经在社交媒体上发声，要求该歌手公开道歉并下架歌曲。这场抄袭风波仍在持续发酵中。</p>',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20music%20studio%20scene%20with%20headphones%20and%20audio%20equipment%20on%20a%20desk%2C%20sheet%20music%20with%20red%20markings%2C%20warm%20studio%20lighting%2C%20creative%20atmosphere%2C%20professional%20music%20production%20setup%2C%20soft%20golden%20ambient%20glow&width=800&height=500&seq=article-cover-11&orientation=landscape',
    author: '音乐侦探',
    publishedAt: '2026-08-02T14:00:00',
    views: 567800,
    comments: 3456,
    tags: ['抄袭风波', '知名歌手', '音乐对比', '原创维权'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'article-12',
    title: '一线女星疑似整容失败，出席活动面部僵硬引热议',
    excerpt: '某一线女星近日出席品牌活动时，面部表情异常僵硬，笑容极不自然，引发网友对其整容的猜测和讨论...',
    content: '<p>近日，某一线女星出席某国际品牌的新品发布会时，其面部状态引发网友热议。现场高清照片显示，该女星面部表情明显僵硬，尤其是在微笑时，苹果肌和嘴角的肌肉运动极不自然，与以往的自然灵动形成鲜明对比。</p><p>不少网友将其近期照片与此前照片进行对比，发现其面部轮廓发生了明显变化：鼻梁更加高挺、下巴更加尖削、嘴唇更加饱满。有医美专业人士分析认为，这些变化很可能是在短期内进行了多项面部填充和塑形手术。</p><p>然而也有粉丝为其辩护，认为只是妆容和灯光效果的问题。该女星的工作室目前未对此做出回应。不过，这场关于整容的讨论已经在网络上持续发酵数日。</p><p>娱乐圈整容话题一直敏感，艺人为了维持竞争力而进行微调本无可厚非，但过度整容导致面部表情丧失，对演技和观众缘反而是巨大伤害。</p>',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20glamorous%20red%20carpet%20event%20scene%20with%20a%20female%20celebrity%20posing%20for%20cameras%2C%20bright%20flash%20photography%2C%20luxury%20brand%20event%20backdrop%2C%20warm%20golden%20event%20lighting%2C%20elegant%20and%20sophisticated%20atmosphere&width=800&height=500&seq=article-cover-12&orientation=landscape',
    author: '颜值观察员',
    publishedAt: '2026-08-01T18:00:00',
    views: 789200,
    comments: 6789,
    tags: ['整容', '一线女星', '面部僵硬', '颜值争议'],
    isHot: false,
    isNew: false,
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getLatestArticles(limit: number = 10): Article[] {
  return [...articles]
    .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())
    .slice(0, limit);
}

export function getRelatedArticles(articleId: string, limit: number = 4): Article[] {
  const current = getArticleById(articleId);
  if (!current) return [];
  return articles
    .filter((a) => a.id !== articleId && a.categorySlug === current.categorySlug)
    .slice(0, limit);
}